import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Laundry Washer",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Experience the convenience of our high-quality laundry washer. Designed for efficiency and reliability, it ensures your clothes are treated with care.",
        description: "Our Laundry Washer is crafted for modern households seeking top performance and gentle cleaning. It features an 8 kg capacity, energy-efficient A++ rating, and durable build. Perfect for tackling everyday laundry with ease, this appliance brings comfort and speed to your laundry routine.",
        category: ["Laundry Essentials", "Cleaning Supplies"],
        tags: ["washing", "bleach", "dryer"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "Laundry Master" },
            { id: 2, title: "Capacity", content: "8 kg" },
            { id: 3, title: "Energy Efficiency", content: "A++" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Emily Davis",
                date: "Dec 31, 2023",
                rating: 4.5,
                content: "This washing machine has made laundry day so much easier for me. It's efficient and easy to use. Highly recommended!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Michael Johnson",
                date: "Jan 01, 2024",
                rating: 4.5,
                content: "I love the modern features of this washing machine. It's a great addition to my laundry routine. Thumbs up!"
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Steam Iron",
        price: 30,
        disprice: 22,
        stock: 15,
        content: "Tackle wrinkles with ease using our powerful Steam Iron. Compact, efficient, and easy to handle — it’s your ultimate fabric-smoothing solution.",
        description: "Our Steam Iron features fast heating, a non-stick soleplate, and a burst steam function that smooths even the toughest creases. With adjustable temperature settings and a sleek ergonomic design, it's perfect for all types of fabrics — from delicate silks to sturdy linens.",
        category: ["Ironing Tools", "Laundry Essentials"],
        tags: ["iron", "steamer", "hangers"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "Laundry Master" },
            { id: 2, title: "Power Output", content: "1800W" },
            { id: 3, title: "Steam Output", content: "25 g/min" },
            { id: 4, title: "Water Tank Capacity", content: "280 ml" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Sophia Bennett",
                date: "Feb 10, 2025",
                rating: 5,
                content: "This steam iron is quick and effective. Makes ironing feel effortless!"
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Liam Carter",
                date: "Feb 14, 2025",
                rating: 4.5,
                content: "Great value for money. Compact and heats up fast — highly recommend it!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Clothes Pins",
        price: 10,
        disprice: 6,
        stock: 5,
        content: "Secure your laundry with durable Clothes Pins. Designed for strong grip and weather resistance — perfect for everyday use.",
        description: "Made from high-quality plastic and stainless steel springs, our Clothes Pins are built to last. They provide a firm grip without damaging your clothes and are resistant to rust and UV exposure. Ideal for indoor and outdoor drying, these pins are essential for every laundry routine.",
        category: ["Clothing Accessories", "Drying Equipment"],
        tags: ["pins", "racks", "bags"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Plastic & Stainless Steel" },
            { id: 2, title: "Pack Size", content: "50 pieces" },
            { id: 3, title: "Grip Strength", content: "High" },
            { id: 4, title: "Weather Resistant", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Chloe Ramirez",
                date: "Mar 3, 2025",
                rating: 5,
                content: "These clothes pins are super strong and don’t slip. Love the bright colors too!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Noah Kim",
                date: "Mar 6, 2025",
                rating: 4,
                content: "Very durable and hold up well even on windy days. A great buy for the price."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Hangers",
        price: 20,
        disprice: 14,
        stock: 0,
        content: "Keep your wardrobe neat with our sturdy and space-saving Hangers. Designed to hold all types of garments without slipping.",
        description: "Our premium hangers are crafted from durable plastic with anti-slip coating to keep clothes in place. The slim design helps maximize closet space, while the contoured shoulders maintain garment shape. Perfect for shirts, dresses, jackets, and more.",
        category: ["Clothing Accessories", "Laundry Essentials"],
        tags: ["hangers", "iron", "washing"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Plastic with Non-Slip Finish" },
            { id: 2, title: "Pack Size", content: "20 pieces" },
            { id: 3, title: "Color Options", content: "Black, White, Gray" },
            { id: 4, title: "Space Saving", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Sophia Li",
                date: "Mar 12, 2025",
                rating: 5,
                content: "Love these hangers! Super slim and strong—my closet looks so organized now."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Ethan Moore",
                date: "Mar 14, 2025",
                rating: 4,
                content: "Good grip and quality. Slightly tight for thicker coats but overall very useful."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Color-Safe Bleach",
        price: 12,
        disprice: 9,
        stock: 5,
        content: "Brighten your clothes without fading the colors using our gentle yet powerful Color-Safe Bleach.",
        description: "This bleach alternative is tough on stains yet gentle on colors and fabrics. Safe for regular use on whites and colors alike, it helps maintain fabric vibrancy while boosting cleaning power. Ideal for machine or hand washing.",
        category:  ["Cleaning Supplies", "Laundry Essentials"],
        tags: ["bleach", "washing", "stain"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Type", content: "Liquid" },
            { id: 2, title: "Volume", content: "1.5 Liters" },
            { id: 3, title: "Safe for Colors", content: "Yes" },
            { id: 4, title: "Usage", content: "Machine & Hand Wash" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Grace Kim",
                date: "Apr 02, 2025",
                rating: 5,
                content: "Finally found a bleach that doesn’t ruin colors! Works great on stains too."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Daniel Rivera",
                date: "Apr 05, 2025",
                rating: 4,
                content: "Keeps clothes fresh and bright. Could be a bit thicker, but still highly recommend."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Clothes Dryer",
        price: 60,
        disprice: 50,
        stock: 12,
        content: "Efficient and gentle drying with our advanced Clothes Dryer, designed to keep your fabrics soft and wrinkle-free.",
        description: "Our Clothes Dryer features multiple heat settings and sensor drying technology to prevent over-drying. Perfect for all fabric types, it reduces drying time while protecting your clothes from damage. Compact design fits easily in most laundry spaces.",
        category: ["Drying Equipment", "Laundry Essentials"],
        tags: ["dryer", "bleach", "washing"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "Laundry Master" },
            { id: 2, title: "Capacity", content: "7 kg" },
            { id: 3, title: "Energy Efficiency", content: "A+" },
            { id: 4, title: "Drying Programs", content: "5 Modes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Sophia Lee",
                date: "Mar 15, 2025",
                rating: 5,
                content: "Dries clothes perfectly every time, and is very quiet too!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "James Carter",
                date: "Mar 20, 2025",
                rating: 4.5,
                content: "Good drying performance and energy efficient, worth the price."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Clothes Rack",
        price: 25,
        disprice: 20,
        stock: 3,
        content: "Keep your laundry organized and wrinkle-free with our sturdy and versatile Clothes Rack.",
        description: "Our Clothes Rack offers ample space for drying clothes indoors or outdoors. Made from durable, rust-resistant materials, it folds easily for convenient storage. Ideal for small spaces and perfect for everyday laundry needs.",
        category: ["Drying Equipment", "Clothing Accessories"],
        tags: ["racks", "pins", "bags"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Steel & Plastic" },
            { id: 2, title: "Dimensions", content: "60 x 40 x 100 cm" },
            { id: 3, title: "Weight Capacity", content: "15 kg" },
            { id: 4, title: "Foldable", content: "Yes" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Laura Kim",
                date: "Apr 5, 2025",
                rating: 5,
                content: "Very sturdy and easy to fold away when not in use."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "David Miller",
                date: "Apr 10, 2025",
                rating: 4,
                content: "Good size and durable build, perfect for my apartment."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Laundry Bag",
        price: 15,
        disprice: 12,
        stock: 0,
        content: "Keep your dirty clothes contained and organized with our durable Laundry Bag.",
        description: "Made from breathable and washable fabric, our Laundry Bag is perfect for storing and transporting laundry. It features a sturdy drawstring closure and reinforced handles for easy carrying. Ideal for dorms, apartments, or travel.",
        category: ["Laundry Essentials", "Clothing Accessories"],
        tags: ["bags", "racks", "pins"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Cotton & Polyester" },
            { id: 2, title: "Capacity", content: "30 liters" },
            { id: 3, title: "Closure", content: "Drawstring" },
            { id: 4, title: "Care Instructions", content: "Machine washable" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Jessica Lee",
                date: "May 3, 2025",
                rating: 5,
                content: "Lightweight and roomy, perfect for my laundry needs."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Mark Thompson",
                date: "May 7, 2025",
                rating: 4.5,
                content: "Durable and easy to carry around campus."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Stain Remover",
        price: 8,
        disprice: 10,
        stock: 10,
        content: "Effectively remove tough stains from your clothes with our powerful Stain Remover.",
        description: "Our stain remover is specially formulated to tackle a wide variety of stains including grease, ink, wine, and grass. Safe for most fabrics, it penetrates deep to lift stains without damaging your clothes. Perfect for pre-treatment before washing.",
        category: ["Cleaning Supplies", "Laundry Essentials"],
        tags: ["stain", "bleach", "washing"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Ingredients", content: "Enzymes & Surfactants" },
            { id: 2, title: "Usage", content: "Pre-treat stains before washing" },
            { id: 3, title: "Suitable Fabrics", content: "Cotton, Polyester, Wool" },
            { id: 4, title: "Safety", content: "Non-toxic, biodegradable" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Laura Green",
                date: "Apr 15, 2025",
                rating: 5,
                content: "Works wonders on stubborn stains. Highly recommend!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "James Brown",
                date: "Apr 18, 2025",
                rating: 4,
                content: "Good product, but a little strong scent for me."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Laundry Washer",
        price: 40,
        disprice: 50,
        stock: 8,
        content: "Experience efficient and reliable cleaning with our top-quality Laundry Washer, designed to handle your laundry with care.",
        description: "Our Laundry Washer features advanced technology for thorough cleaning while being gentle on fabrics. With an 8 kg capacity and energy-efficient A++ rating, it’s perfect for everyday use. Enjoy quiet operation and multiple wash settings for all your laundry needs.",
        category: ["Laundry Essentials", "Cleaning Supplies"],
        tags: ["washing", "dryer", "stain"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "Laundry Master" },
            { id: 2, title: "Capacity", content: "8 kg" },
            { id: 3, title: "Energy Efficiency", content: "A++" },
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Emily Davis",
                date: "Dec 31, 2023",
                rating: 4.5,
                content: "This laundry washer has made laundry day so much easier for me. It's efficient and easy to use. Highly recommended!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Michael Johnson",
                date: "Jan 01, 2024",
                rating: 5,
                content: "I love the modern features of this laundry washer. It's a great addition to my laundry routine. Thumbs up!"
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Garment Steamer",
        price: 40,
        disprice: 50,
        stock: 10,
        content: "Keep your clothes wrinkle-free and fresh with our efficient and easy-to-use Garment Steamer.",
        description: "Our Garment Steamer offers powerful steam output for quick and gentle wrinkle removal. Perfect for delicate fabrics and quick touch-ups, it heats up fast and is lightweight for convenient use at home or on the go.",
        category: ["Ironing Tools", "Laundry Essentials"],
        tags: ["steamer", "iron", "hangers"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "SteamPro" },
            { id: 2, title: "Power", content: "1500W" },
            { id: 3, title: "Water Tank Capacity", content: "250 ml" },
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Sophia Turner",
                date: "Mar 10, 2024",
                rating: 5,
                content: "The garment steamer works wonders on my delicate clothes. Easy to use and super effective!"
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Liam Smith",
                date: "Mar 12, 2024",
                rating: 4.5,
                content: "Great steamer for quick touch-ups. Lightweight and heats up fast."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Laundry Clips",
        price: 5,
        disprice: 8,
        stock: 50,
        content: "Secure your clothes with our durable and weather-resistant Laundry Clips, perfect for indoor and outdoor use.",
        description: "These Laundry Clips feature a strong grip and are made from high-quality plastic to keep your garments firmly in place. Ideal for hanging laundry on lines or racks without slipping, they withstand different weather conditions and are easy to handle.",
        category: ["Clothing Accessories", "Drying Equipment"],
        tags: ["pins", "bags", "racks"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Durable Plastic" },
            { id: 2, title: "Color Options", content: "Blue, Green, Red, Yellow" },
            { id: 3, title: "Pack Size", content: "Set of 20" },
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Emma Williams",
                date: "Apr 5, 2024",
                rating: 5,
                content: "Strong clips that hold my clothes perfectly, even on windy days!"
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Noah Brown",
                date: "Apr 7, 2024",
                rating: 4,
                content: "Good quality clips at an affordable price. Highly recommend."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Clothing Hangers",
        price: 10,
        disprice: 15,
        stock: 75,
        content: "Keep your clothes organized and wrinkle-free with our sleek and sturdy Clothing Hangers.",
        description: "Crafted from durable materials, these hangers provide excellent support for all types of garments. Their smooth finish prevents snagging, making them ideal for delicate fabrics as well. Available in multiple colors and styles to suit your closet needs.",
        category: ["Clothing Accessories", "Laundry Essentials"],
        tags: ["hangers", "iron", "steamer"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Plastic and Metal" },
            { id: 2, title: "Color Options", content: "Black, White, Blue" },
            { id: 3, title: "Pack Size", content: "Set of 10" },
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Sophia Martinez",
                date: "Mar 22, 2024",
                rating: 5,
                content: "Strong and smooth hangers that keep my clothes wrinkle-free."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Liam Garcia",
                date: "Mar 25, 2024",
                rating: 4.5,
                content: "Good quality and nice design. Perfect for my wardrobe."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Fabric-Safe Bleach",
        price: 12,
        disprice: 18,
        stock: 60,
        content: "Gentle yet effective bleach specially formulated to brighten and whiten your fabrics without damage.",
        description: "Our Fabric-Safe Bleach removes tough stains and maintains the color and texture of your clothes. Safe for use on most fabrics, it is ideal for laundry care that demands both cleanliness and fabric protection.",
        category: ["Cleaning Supplies", "Laundry Essentials"],
        tags: ["bleach", "stain", "washing"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Usage", content: "Safe for colors and whites" },
            { id: 2, title: "Volume", content: "1 Liter" },
            { id: 3, title: "Ingredients", content: "Non-chlorine formula" },
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Emma Brown",
                date: "Apr 10, 2024",
                rating: 5,
                content: "Brightens my clothes without fading colors. Highly recommend!"
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Noah Wilson",
                date: "Apr 12, 2024",
                rating: 4,
                content: "Good product, gentle on fabrics, effective on stains."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Clothes Dryer",
        price: 120,
        disprice: 150,
        stock: 10,
        content: "Efficient and reliable clothes dryer designed to quickly dry your laundry while protecting fabric quality.",
        description: "Our Clothes Dryer features multiple drying settings, energy-saving modes, and a spacious drum capacity to handle large loads with ease. It’s perfect for fast drying, wrinkle reduction, and softening fabrics for everyday convenience.",
        category: ["Drying Equipment", "Laundry Essentials"],
        tags: ["dryer", "washing", "bags"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Brand", content: "Laundry Master" },
            { id: 2, title: "Capacity", content: "9 kg" },
            { id: 3, title: "Energy Efficiency", content: "A+" },
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Sophia Lee",
                date: "Mar 5, 2024",
                rating: 5,
                content: "Dries clothes fast and gently. A great addition to my laundry room."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "James Carter",
                date: "Mar 7, 2024",
                rating: 4,
                content: "Quiet operation and efficient drying. Very happy with this purchase."
            }
        ]
    },

];

export default products;